import { Check } from '@styled-icons/boxicons-regular';
import { ChevronDown } from '@styled-icons/feather';
import type { StyledIcon } from '@styled-icons/styled-icon';
import {
  ReactNode, useEffect, useRef, useState,
} from 'react';
import selectMediaStyles from '../SelectMedia.module.css';
import styles from './SelectMediaLink.module.css';

export interface SelectMediaLinkProps {
  acceptedTypes?: Array<{ type: string; label: string; icon: StyledIcon }>
  onSelect: (url: string, type?: string) => void
  disabled?: boolean
  placeholder?: string
  button: string
  defaultValue?: string
  description?: ReactNode
}

export function SelectMediaLink(props: SelectMediaLinkProps) {
  const {
    acceptedTypes,
    onSelect,
    placeholder,
    button,
    defaultValue,
    disabled,
    description,
  } = props;

  const [selectedType, setSelectedType] = useState(acceptedTypes?.[0]?.type);
  const [openTypeDropdown, setOpenTypeDropdown] = useState(false);

  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  return (
    <form
      className={selectMediaStyles.tabContent}
      autoComplete="off"
      onSubmit={(e) => {
        e.preventDefault();
        const data = new FormData(e.target as HTMLFormElement);
        const url = data.get('url');
        if (url) {
          onSelect(url as string, selectedType);
        }
      }}
    >
      <div className={styles.inputContainer}>
        {acceptedTypes && (
          <div
            // ref={dropdownRef}
            className={styles.inputTypeDropdownContainer}
          >
            <button
              type="button"
              className={styles.inputTypeDropdownTrigger}
              onClick={() => setOpenTypeDropdown((v) => !v)}
            >
              {/* there should be only one item rendered here */}
              {acceptedTypes
                .filter(({ type }) => type === selectedType)
                .map(({ type, icon: Icon }) => (
                  <Icon key={type} size={24} />
                ))}

              <ChevronDown
                size={15}
                style={{
                  transition: 'transform 0.3s',
                  transform: openTypeDropdown ? 'rotate(-180deg)' : undefined,
                }}
              />
            </button>

            {openTypeDropdown && (
              <div className={styles.inputTypeDropdown}>
                {acceptedTypes.map(({ type, icon: Icon }) => (
                  <div
                    key={type}
                    role="none"
                    className={styles.inputTypeDropdownItem}
                    onClick={() => {
                      setSelectedType(type);
                      setOpenTypeDropdown(false);
                    }}
                  >
                    <div>
                      <Icon size={20} className="mr-2" />
                      {type}
                    </div>
                    {selectedType === type && <Check size={15} />}
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
        <input
          ref={inputRef}
          type="text"
          name="url"
          placeholder={placeholder}
          className={styles.input}
          defaultValue={defaultValue}
          disabled={disabled}
        />
      </div>

      <button
        type="submit"
        className={selectMediaStyles.button}
        disabled={disabled}
      >
        {button}
      </button>

      {description && (
        <div className={selectMediaStyles.description}>{description}</div>
      )}
    </form>
  );
}

SelectMediaLink.defaultProps = {
  acceptedTypes: undefined,
  placeholder: undefined,
  defaultValue: undefined,
  disabled: false,
  description: undefined,
};
